import React, { Component } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { isDatadogEnabled } from "utils/datadog";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    console.error("React Error Boundary caught error:", error, errorInfo);

    if (isDatadogEnabled()) {
      datadogRum.addError(error, {
        source: "react-error-boundary",
        componentStack: errorInfo.componentStack
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Oops, Something went wrong!.</h1>
        </div>
      );
    }
    return this.props.children;
  }
}
